import React, { useEffect, useState, useRef } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { YEARS } from "../../utils/constantData";
import { getHelplineLogs } from ".";
import { getGraphData } from "../../utils/graphManager";
import { PDFGenerator } from "../common/PdfGenerator";
import { ExportExcel } from "../common/ExcelGenerator";
import { ExportCSV } from "../common/CsvGenerator";
import { barChartOptions } from "../../utils/chartTheme";
import { buildDateRangeParams } from "../common/DateRangeFilter";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const labels = YEARS;

function getData(data) {
  return {
    labels,
    data: data,
    datasets: [
      {
        label: "Helpline Logs",
        data: data,
        backgroundColor: "rgba(164, 75, 18, 0.76)",
        borderRadius: 10,
        maxBarThickness: 34,
        pointRadius: 0,
      },
    ],
  };
}

export default function UserHelplineLogComponent({ dateFilter }) {
  const [data, setData] = useState({});
  const [dataPdf, setDataPdf] = useState([]);

  const chartRef = useRef(null);

  function getCount(data) {
    return Object.keys(data).map((key) => {
      const count = data[key]?.count || 0;
      const dataP = data[key].users;
      setDataPdf((prevData) => {
        const isDuplicate = prevData.some((item) => item.key === key);
        if (!isDuplicate) {
          return [...prevData, { data: dataP, key: key }];
        }
        return prevData;
      });
      return [0, count];
    });
  }

  useEffect(() => {
    setDataPdf([]);
    async function fetchData() {
      try {
        const response = await getHelplineLogs(buildDateRangeParams(dateFilter));
        const responseData = response.data;
        setData(getCount(responseData?.data || {}));
      } catch (error) {
        console.log(error);
      }
    }

    fetchData();
  }, [dateFilter]);

  
  return (
    <div className="chart-panel">
      <div className="chart-panel__header">
        <div>
          <span className="chart-panel__eyebrow">Support</span>
          <h2 className="chart-panel__title">Helpline activity</h2>
          <p className="chart-panel__description">
            Review how often users are reaching out so service demand is easy to spot.
          </p>
        </div>
      </div>
      <div className="chart-canvas">
        <Bar
          ref={(ref) => {
            chartRef.current = ref;
          }}
          options={barChartOptions}
          data={getData(getGraphData(data))}
        />
      </div>
      <div className="chart-actions">
        <ExportExcel fileName="helpline log" excelData={dataPdf} />
        <ExportCSV fileName="helpline log" csvData={dataPdf} />
        <PDFGenerator data={dataPdf} name="helpline log" />
      </div>
    </div>
  );
}
